import * as React from "react"

import { cn } from "@/lib/utils"

// Tarayıcının (özellikle Chrome/Edge) kredi kartı, adres ve profil
// bilgilerini ERP inputlarına otomatik doldurmasını engelleyen
// varsayılan öznitelikler. Çağıran bileşen kendi `autoComplete`
// prop'unu geçerse (ör. Login sayfasında "email" / "current-password")
// varsayılan geçersiz kılınır.
const AUTOFILL_BLOCKERS = {
  autoComplete: "off",
  autoCorrect: "off",
  autoCapitalize: "off",
  spellCheck: false,
  "data-lpignore": "true",
  "data-form-type": "other",
};

// Kredi-kartı heuristiğini kırmak için tahmin edilemez rastgele name.
// Aynı name Chrome'da hafızaya alınmasın diye her render'da yeni değil,
// component başına stabil bir değer üretiyoruz.
function useRandomName(prefix = "f") {
  return React.useMemo(() => `${prefix}-${Math.random().toString(36).slice(2, 10)}`, []);
}

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  const randomName = useRandomName("in");
  const blockers = { ...AUTOFILL_BLOCKERS };
  // Password/email gibi Chrome şifre yöneticisi ile çalışması gereken
  // alanlarda çağıran zaten autoComplete belirtiyor -> onu koru.
  const merged = { ...blockers, ...props };
  // name verilmediyse rastgele koy; verilmişse dokunma
  if (merged.name === undefined) merged.name = randomName;
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...merged} />
  );
})
Input.displayName = "Input"

export { Input }
